export default {"src":"/uk/_next/static/media/spot-deny.9f0606f2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};